import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import { oneLineTrim } from 'common-tags';

function* fetchFactoryReport({ factoryReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactoryReports
             /${factoryReportParams.factoryId}
             /${factoryReportParams.groupId}
             /${factoryReportParams.unitId}
             /${factoryReportParams.fromDate}
             /${factoryReportParams.fromShift}
             /${factoryReportParams.toDate}
             /${factoryReportParams.toShift}`,
    });
    const factoryReport = data;
    yield put(Actions.setFactoryReport({ factoryReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchFactoryOeeReport({ factoryReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactoryOeeReport
             /${factoryReportParams.factoryId}
             /${factoryReportParams.groupId}
             /${factoryReportParams.fromDate}
             /${factoryReportParams.fromShift}
             /${factoryReportParams.toDate}
             /${factoryReportParams.toShift}`,
    });
    const factoryOeeReport = data;
    yield put(Actions.setFactoryOeeReport({ factoryOeeReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchFactoryAvailabilityReport({ factoryReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactoryAvailabilityReport
             /${factoryReportParams.factoryId}
             /${factoryReportParams.groupId}
             /${factoryReportParams.fromDate}
             /${factoryReportParams.fromShift}
             /${factoryReportParams.toDate}
             /${factoryReportParams.toShift}`,
    });
    const factoryAvailabilityReport = data;
    yield put(Actions.setFactoryAvailabilityReport({ factoryAvailabilityReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchFactoryPerformanceReport({ factoryReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactoryPerformanceReport
             /${factoryReportParams.factoryId}
             /${factoryReportParams.groupId}
             /${factoryReportParams.fromDate}
             /${factoryReportParams.fromShift}
             /${factoryReportParams.toDate}
             /${factoryReportParams.toShift}`,
    });
    const factoryPerformanceReport = data;
    yield put(Actions.setFactoryPerformanceReport({ factoryPerformanceReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchFactoryQualityReport({ factoryReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactoryQualityReport
             /${factoryReportParams.factoryId}
             /${factoryReportParams.groupId}
             /${factoryReportParams.fromDate}
             /${factoryReportParams.fromShift}
             /${factoryReportParams.toDate}
             /${factoryReportParams.toShift}`,
    });
    const factoryQualityReport = data;
    yield put(Actions.setFactoryQualityReport({ factoryQualityReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchFactoryDetailReport({ factoryDetailReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/DetailFactoryReport
             /${factoryDetailReportParams.factoryId}
             /${factoryDetailReportParams.unitId}
             /${factoryDetailReportParams.fromDate}
             /${factoryDetailReportParams.fromShift}
             /${factoryDetailReportParams.toDate}
             /${factoryDetailReportParams.toShift}`,
    });
    const factoryDetailReport = data;
    yield put(Actions.setFactoryDetailReport({ factoryDetailReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchFactoryDayReport({ factoryDayReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactoryDayReport
             /${factoryDayReportParams.factoryId}
             /${factoryDayReportParams.unitId}
             /${factoryDayReportParams.day}`,
    });
    const factoryDayReport = data;
    yield put(Actions.setFactoryDayReport({ factoryDayReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchEnergyReport({ energyReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EnergyReport
             /${energyReportParams.factoryId}
             /${energyReportParams.groupId}
             /${energyReportParams.fromDate}
             /${energyReportParams.fromShift}
             /${energyReportParams.toDate}
             /${energyReportParams.toShift}`,
    });
    const energyReport = data;
    yield put(Actions.setEnergyReport({ energyReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchShiftReport({ shiftReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/ShiftReport
             /${shiftReportParams.factoryId}
             /${shiftReportParams.groupId}
             /${shiftReportParams.equipmentId}
             /${shiftReportParams.shiftId}
             /${shiftReportParams.unitId}
             /${shiftReportParams.date}`,
    });
    const shiftReport = data;
    yield put(Actions.setShiftReport({ shiftReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchEquipmentDowntimes({ equipmentDowntimesParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EquipmentDowntimes
             /${equipmentDowntimesParams.factoryId}
             /${equipmentDowntimesParams.equipmentId}
             /${equipmentDowntimesParams.shiftId}
             /${equipmentDowntimesParams.date}`,
    });
    const equipmentDowntimes = data;
    yield put(Actions.setEquipmentDowntimes({ equipmentDowntimes }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchEquipmentEfficiencyReport({ equipmentEfficiencyReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EquipmentEfficiencyReport
             /${equipmentEfficiencyReportParams.factoryId}
             /${equipmentEfficiencyReportParams.equipmentId}
             /${equipmentEfficiencyReportParams.unitId}
             /${equipmentEfficiencyReportParams.fromDate}
             /${equipmentEfficiencyReportParams.fromShift}
             /${equipmentEfficiencyReportParams.toDate}
             /${equipmentEfficiencyReportParams.toShift}`,
    });
    const equipmentEfficiencyReport = data;
    yield put(Actions.setEquipmentEfficiencyReport({ equipmentEfficiencyReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchEquipmentOeeReport({ equipmentReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EquipmentOeeReport
             /${equipmentReportParams.factoryId}
             /${equipmentReportParams.equipmentId}
             /${equipmentReportParams.fromDate}
             /${equipmentReportParams.fromShift}
             /${equipmentReportParams.toDate}
             /${equipmentReportParams.toShift}`,
    });
    const equipmentOeeReport = data;
    yield put(Actions.setEquipmentOeeReport({ equipmentOeeReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchEquipmentAvailabilityReport({ equipmentReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EquipmentAvailabilityReport
             /${equipmentReportParams.factoryId}
             /${equipmentReportParams.equipmentId}
             /${equipmentReportParams.fromDate}
             /${equipmentReportParams.fromShift}
             /${equipmentReportParams.toDate}
             /${equipmentReportParams.toShift}`,
    });
    const equipmentAvailabilityReport = data;
    yield put(Actions.setEquipmentAvailabilityReport({ equipmentAvailabilityReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchEquipmentPerformanceReport({ equipmentReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EquipmentPerformanceReport
             /${equipmentReportParams.factoryId}
             /${equipmentReportParams.equipmentId}
             /${equipmentReportParams.fromDate}
             /${equipmentReportParams.fromShift}
             /${equipmentReportParams.toDate}
             /${equipmentReportParams.toShift}`,
    });
    const equipmentPerformanceReport = data;
    yield put(Actions.setEquipmentPerformanceReport({ equipmentPerformanceReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}
function* fetchEquipmentQualityReport({ equipmentReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/EquipmentQualityReport
             /${equipmentReportParams.factoryId}
             /${equipmentReportParams.equipmentId}
             /${equipmentReportParams.fromDate}
             /${equipmentReportParams.fromShift}
             /${equipmentReportParams.toDate}
             /${equipmentReportParams.toShift}`,
    });
    const equipmentQualityReport = data;
    yield put(Actions.setEquipmentQualityReport({ equipmentQualityReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchProductEfficiencyReport({ productEfficiencyReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/ProductEfficiencyReport
             /${productEfficiencyReportParams.factoryId}
             /${productEfficiencyReportParams.toolId}
             /${productEfficiencyReportParams.productId}
             /${productEfficiencyReportParams.unitId}
             /${productEfficiencyReportParams.fromDate}
             /${productEfficiencyReportParams.fromShift}
             /${productEfficiencyReportParams.toDate}
             /${productEfficiencyReportParams.toShift}`,
    });
    const productEfficiencyReport = data;
    yield put(Actions.setProductEfficiencyReport({ productEfficiencyReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchRejectionReport({ rejectionReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/RejectionReport
             /${rejectionReportParams.factoryId}
             /${rejectionReportParams.groupId}
             /${rejectionReportParams.lineId}
             /${rejectionReportParams.equipmentId}
             /${rejectionReportParams.jobId}
             /${rejectionReportParams.fromDate}
             /${rejectionReportParams.fromShift}
             /${rejectionReportParams.toDate}
             /${rejectionReportParams.toShift}
             /${rejectionReportParams.rejectionReasonTypeId}`,
    });
    const rejectionReport = data;
    yield put(Actions.setRejectionReport({ rejectionReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchDowntimeReport({ downtimeReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/CustomDowntimeReport
             /${downtimeReportParams.factoryId}
             /${downtimeReportParams.groupId}
             /${downtimeReportParams.lineId}
             /${downtimeReportParams.equipmentId}
             /${downtimeReportParams.fromDate}
             /${downtimeReportParams.fromShift}
             /${downtimeReportParams.toDate}
             /${downtimeReportParams.toShift}`,
    });
    const downtimeReport = data;
    yield put(Actions.setDowntimeReport({ downtimeReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchCustomJobReport({ jobReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/CustomJobReport
             /${jobReportParams.factoryId}`,
    });
    const customJobReport = data;
    yield put(Actions.setCustomJobReport({ customJobReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchDowntimeAnalysisReport({ downtimeAnalysisReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/GetDownTime
            /${downtimeAnalysisReportParams.factoryId}
            /${downtimeAnalysisReportParams.fromDate}
            /${downtimeAnalysisReportParams.fromShift}
            /${downtimeAnalysisReportParams.toDate}
            /${downtimeAnalysisReportParams.toShift}`,
    });
    const downtimeAnalysisReport = data;
    yield put(Actions.setDowntimeAnalysisReport({ downtimeAnalysisReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchToolAnalysisReport({ toolAnalysisReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/GetDownTimeWithToolId
            /${toolAnalysisReportParams.reasonId}
            /${toolAnalysisReportParams.factoryId}
            /${toolAnalysisReportParams.fromDate}
            /${toolAnalysisReportParams.fromShift}
            /${toolAnalysisReportParams.toDate}
            /${toolAnalysisReportParams.toShift}`,
    });
    const toolAnalysisReport = data;
    yield put(Actions.setToolAnalysisReport({ toolAnalysisReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

function* fetchJobReport({ jobReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/GetDetailJobReport
      /${jobReportParams.factoryId}
      /${jobReportParams.jobId}`,
    });
    const jobReport = data;
    yield put(Actions.setJobReport({ jobReport }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setJobReport({}));
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error);
  }
}

function* fetchEquipmentsByGroup({ groupId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'Equipment/getequipmentsbygroup/' + groupId,
    });
    const groupEquipments = data;
    yield put(Actions.setEquipmentsByGroup({ groupEquipments }));
  } catch (error) {
    console.warn(error);
  }
}

function* fetchLinesByGroup({ groupId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'Line/getlinesbygroup/' + groupId,
    });
    const groupLines = data;
    yield put(Actions.setLinesByGroup({ groupLines }));
  } catch (error) {
    console.warn(error);
  }
}

function* fetchUnitTypeByFactory({ factoryId }) {
  try {
    const { data } = yield call(api.get, {
      route: 'Reports/GetUnitTypeByFactory',
      params: factoryId,
    });
    const factoryUnits = data;
    yield put(Actions.setUnitTypeByFactory({ factoryUnits }));
  } catch (error) {
    console.warn(error);
  }
}

function* fetchPowerBiTokenMultiDb({ reportName }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield put(Actions.setPowerBiEmbedData({ powerBiApiEmbedData: null }));
    const { data } = yield call(api.get, {
      route: 'PowerBi/GetPowerBiCustomerEmbedParams/' + reportName,
    });
    const powerBiApiEmbedData = data.toJS();
    yield put(Actions.setPowerBiEmbedData({ powerBiApiEmbedData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error);
  }
}
function* refreshPowerBIReportDataset({ reportName, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    yield call(api.get, {
      route: 'PowerBi/RefreshDatasetData/' + reportName,
    });

    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchPowerBiToken({ reportName }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error);
  }
}

function* export_to_file_in_group({ reportName, fileFormat, userEmail }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    yield call(api.get, {
      route: 'PowerBi/ExportToFileInGroup/' + reportName + '/' + fileFormat + '/' + userEmail,
    });
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error);
  }
}

function* fetchFactorySummaryReport({ factoryReportParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: oneLineTrim`Reports/FactorySummaryReport
             /${factoryReportParams.factoryId}
             /${factoryReportParams.groupId}
             /${factoryReportParams.dateTime}
             /${factoryReportParams.shiftId}`,
    });
    const factorySummaryReportData = data;
    yield put(Actions.setFactorySummaryReport({ factorySummaryReportData }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_FACTORY_REPORT, fetchFactoryReport),
    takeLatest(ActionTypes.FETCH_FACTORY_OEE_REPORT, fetchFactoryOeeReport),
    takeLatest(ActionTypes.FETCH_FACTORY_AVAILABILITY_REPORT, fetchFactoryAvailabilityReport),
    takeLatest(ActionTypes.FETCH_FACTORY_PERFORMANCE_REPORT, fetchFactoryPerformanceReport),
    takeLatest(ActionTypes.FETCH_FACTORY_QUALITY_REPORT, fetchFactoryQualityReport),
    takeLatest(ActionTypes.FETCH_FACTORY_DETAIL_REPORT, fetchFactoryDetailReport),
    takeLatest(ActionTypes.FETCH_FACTORY_DAY_REPORT, fetchFactoryDayReport),
    takeLatest(ActionTypes.FETCH_ENERGY_REPORT, fetchEnergyReport),
    takeLatest(ActionTypes.FETCH_SHIFT_REPORT, fetchShiftReport),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_DOWNTIMES, fetchEquipmentDowntimes),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_EFFICIENCY_REPORT, fetchEquipmentEfficiencyReport),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_OEE_REPORT, fetchEquipmentOeeReport),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_AVAILABILITY_REPORT, fetchEquipmentAvailabilityReport),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_PERFORMANCE_REPORT, fetchEquipmentPerformanceReport),
    takeLatest(ActionTypes.FETCH_EQUIPMENT_QUALITY_REPORT, fetchEquipmentQualityReport),
    takeLatest(ActionTypes.FETCH_PRODUCT_EFFICIENCY_REPORT, fetchProductEfficiencyReport),
    takeLatest(ActionTypes.FETCH_REJECTION_REPORT, fetchRejectionReport),
    takeLatest(ActionTypes.FETCH_DOWNTIME_REPORT, fetchDowntimeReport),
    takeLatest(ActionTypes.FETCH_CUSTOM_JOB_REPORT, fetchCustomJobReport),
    takeLatest(ActionTypes.FETCH_DOWNTIME_ANALYSIS_REPORT, fetchDowntimeAnalysisReport),
    takeLatest(ActionTypes.FETCH_TOOL_ANALYSIS_REPORT, fetchToolAnalysisReport),
    takeLatest(ActionTypes.FETCH_JOB_REPORT, fetchJobReport),
    takeLatest(ActionTypes.FETCH_UNIT_TYPE_BY_FACTORY, fetchUnitTypeByFactory),
    takeLatest(ActionTypes.FETCH_EQUIPMENTS_BY_GROUP, fetchEquipmentsByGroup),
    takeLatest(ActionTypes.FETCH_LINES_BY_GROUP, fetchLinesByGroup),
    takeLatest(ActionTypes.FETCH_POWER_BI_TOKEN, fetchPowerBiTokenMultiDb),
    takeLatest(ActionTypes.REFRESH_POWER_BI_DATASET, refreshPowerBIReportDataset),
    takeLatest(ActionTypes.EXPORT_TO_FILE_IN_GROUP, export_to_file_in_group),
    takeLatest(ActionTypes.FETCH_FACTORY_SUMMARY_REPORT, fetchFactorySummaryReport),
  ]);
}
